import type CreativeSDK from '@cesdk/cesdk-js';
import { GQLMerchDecorationFragment } from '@theprintbar/graphql';
import { getDecorationPositionAsPercentage, getSizedImageSourceSet } from '@theprintbar/shared';

export async function addMerchToPage(editor: CreativeSDK, decoration: GQLMerchDecorationFragment, page: number) {
	const { block } = editor.engine;

	const imageBlock = block.create('graphic');
	const rectShape = block.createShape('rect');
	const fill = block.createFill('image');

	const image = decoration?.design?.image;
	if (!image) {
		console.log('Image not found for merch side', decoration.side?.side);
		return;
	}

	const { width, height, left, top } = getDecorationPositionAsPercentage(decoration);

	block.setWidth(imageBlock, width);
	block.setWidthMode(imageBlock, 'Percent');
	block.setHeight(imageBlock, height);
	block.setHeightMode(imageBlock, 'Percent');
	block.appendChild(page, imageBlock);

	block.setSourceSet(
		fill,
		'fill/image/sourceSet',
		getSizedImageSourceSet({
			url: image.url,
			originalWidth: decoration.width,
			originalHeight: decoration.height,
		}),
	);

	block.setFill(imageBlock, fill);
	block.setShape(imageBlock, rectShape);
	block.setKind(imageBlock, 'image');

	setTimeout(() => {
		block.setPositionX(imageBlock, left);
		block.setPositionXMode(imageBlock, 'Percent');
		block.setPositionY(imageBlock, top);
		block.setPositionYMode(imageBlock, 'Percent');
	}, 200);
}
